import React, { useState } from 'react';
import '../styles/ScopeCard.css';

function ScopeCard({ metadata, onApprove, onDecline, disabled }) {
  const {
    title,
    summary,
    deliverables = [],
    estimated_cost_cents = 0,
    timeline,
  } = metadata || {};

  // Permanent disable: starts from persisted card_state (survives refresh),
  // flips immediately on click (no gap before backend responds)
  const [localState, setLocalState] = useState(metadata?.card_state || null);
  const isDisabled = disabled || !!localState;

  const formatPrice = (cents) => {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  return (
    <div className="scope-card">
      <div className="scope-card-header">
        <h3 className="scope-card-title">📋 {title || 'Project Scope'}</h3>
        {timeline && <span className="scope-card-timeline">{timeline}</span>}
      </div>

      {summary && <p className="scope-card-summary">{summary}</p>}

      {deliverables.length > 0 && (
        <div className="scope-card-deliverables">
          <h4 className="deliverables-title">What you'll get:</h4>
          <ul className="deliverables-list">
            {deliverables.map((item, index) => (
              <li key={index} className="deliverable-item">
                <span className="deliverable-check">✓</span>
                {item}
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="scope-card-footer">
        <div className="scope-card-price">
          <span className="price-label">Total</span>
          <span className="price-value">{formatPrice(estimated_cost_cents)}</span>
        </div>

        <div className="scope-card-actions">
          <button
            onClick={() => { setLocalState('declined'); onDecline(); }}
            className="btn btn-ghost scope-btn"
            disabled={isDisabled}
          >
            Request Changes
          </button>
          <button
            onClick={async () => {
              setLocalState('approved');
              try {
                const result = await onApprove();
                // Release lock on retryable outcomes
                const retryableActions = new Set([
                  'declined', 'validation_failed', 'payment_failed', 'usdc_in_flight', 'usdc_unavailable'
                ]);
                if (result?.action && retryableActions.has(result.action)) {
                  setLocalState(null);
                }
              } catch (err) {
                // Network error = unknown outcome, keep locked
                console.error('Approve failed:', err);
              }
            }}
            className="btn btn-primary scope-btn"
            disabled={isDisabled}
          >
            Approve & Pay
          </button>
        </div>
      </div>
    </div>
  );
}

export default ScopeCard;
